const stimulusUiService = {
    layoutClassName(showStimulus, stimulusPosition) {
        if (!showStimulus) {
            return '';
        }
        return `${stimulusPosition || 'left'}-stimulus`;
    },
};

export default stimulusUiService;
